import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';

import { MenuModule } from '../menu/menu.module';
import { ServiceHeaderComponent } from './components/service-header.component';
import { VisitorHeaderComponent } from './components/visitor-header/visitor-header.component';

@NgModule({
    declarations: [VisitorHeaderComponent, ServiceHeaderComponent],
    imports: [CommonModule, BrowserModule, TranslateModule, MenuModule],
    exports: [ServiceHeaderComponent],
})
export class ServiceHeaderModule {}
